import { prefixLanguage } from '@utils/urls'

export const API_BASE_URL = '/api/v1/'
export const prefixAPI = (url: string | null, model = ''): string =>
  API_BASE_URL + model + url

const paginationKeys = 'limit,offset'
export const queryPostfix = (s: string, p?: string[]) =>
  p ? `${s}{?${paginationKeys},${p.join(',')}}` : `${s}{?${paginationKeys}}`
